import Cookies from 'js-cookie';
import { translate } from '~/i18n/i18n.config.js';

const locale = Cookies.get('i18n_redirected');
const token = Cookies.get('auth_token');

const constants = {
  genderOptions: [
    {
      id: 1,
      label: translate('male'),
    },
    { id: 2, label: translate('female') },
  ],

  gender: {
    MALE: 1,
    FEMALE: 2,
    MIXED_GENDER: 3,
    NOT_GENDER: 4,
  },

  ownershipForm: {
    ORGANIZATION: 1,
  },

  address_fields: [
    'postal_code',
    'region_code',
    'district_code',
    'locality_code',
    'sub_locality_code',
    'street_code',
    'house',
    'flat',
  ],

  userRoles: {
    ADMIN: 1,
    VETERINARIAN: 2,
    SHTP: 3,
    LOCAL_EPIZOOTOLOGIST: 4,
    ORGANIZATION_ADMIN: 5,
    REGIONAL_REPRESENTATIVE: 6,
    AGENCY: 7,
    CENTRAL_WAREHOUSE: 8,
    DISTRICT_REPRESENTATIVE: 9,
    COUNTERPARTY: 10,
    VETERINARIAN_REGISTRATOR: 11,
    LABORATORY: 12,
    INTEGRATOR: 13,
  },

  timeTypes: {
    SECOND: 37,
    MINUTE: 36,
    HOUR: 35,
    DAY: 34,
    WEEK: 33,
    MONTH: 32,
    YEAR: 31,
  },

  defaultTableOptions: {
    dataSendParams: {
      size: 'per_page',
    },
    ajaxConfig: {
      headers: {
        Accept: 'application/json',
        'Accept-language': locale,
        Authorization: `Bearer ${token}`,
      },
    },
    // for ajaxConfig use getDefaultTableOptions from helpers
    headerSortClickElement: 'icon',
    printAsHtml: true,
    // printStyled: true,
    printConfig: {
      // columnHeaders: false,
      // columnGroups: false,
      // rowGroups: false,
      // columnCalcs: false,
      // dataTree: false,
      // formatCells: false,
    },
    reactiveData: true,
    movableColumns: true,
    layout: 'fitDataFill',
    layoutColumnsOnNewData: true,
    resizableColumnFit: true,
    pagination: true,
    paginationMode: 'remote',
    paginationCounter: 'rows',
    paginationSize: 10,
    columns: [],
  },
  // for tableOptions
  customPerPageOptions: [
    { id: 10, label: 10 },
    { id: 40, label: 40 },
    { id: 100, label: 100 },
    { id: 150, label: 150 },
    { id: 200, label: 200 },
  ],
  bird_ids: [19, 20, 21, 22, 23, 24, 25],
  fish_ids: [38, 39, 40, 41, 42],
  animal_kinds: {
    COW: 1,
    PIG: 2,
    HORSE: 3,
    BEE: 4,
    DOG: 5,
    CAT: 6,
    DEER: 7,
    MARAL: 8,
    CAMEL: 9,
    DONKEY: 10,
    BISON: 11,
    GOST: 12,
    SHEEP: 13,
    MULE: 14,
    LOSHAK: 15,
    ZEBU: 16,
    BUFFALO: 17,
    GRUNTING_OX: 18,
    CHICKEN: 19,
    DUCK: 20,
    GOOSE: 21,
    TURKEY: 22,
    GUINEA_FOWL: 23,
    QUAIL: 24,
    OSTRICH: 25,
    FOX: 26,
    SABLE: 27,
    MINK: 28,
    FERRET: 29,
    RABBIT: 30,
    ARCTIC_FOX: 31,
    RACCOON_DOG: 32,
    NUTRIA: 33,
    ALPACAS: 34,
    PHEASANT: 35,
    PEACOCK: 36,
    RACCOON: 37,
    STURGEON: 38,
    SALMON: 39,
    CARP: 40,
    CATFISH: 41,
    BASS: 42,
  },
  mask_regex: {
    INTEGER: '^[0-9]*$',
    DECIMAL: '^[0-9]{1,10}[.]?[0-9]{1}$',
    HUNDREDTHS: '^([0]{1}[.][0-9]{1,2}|[1-9][0-9]*[.]?[0-9]{1,2})$',
    THOUSANDS: '^([0]{1}[.][0-9]{1,2}|[1-9][0-9]*[.]?[0-9]{1,3})$',
    // HUNDREDTHS: '^([0]{1}[\.]|[1-9]{1,10}[\.]?)[0-9]{1,2}$',
    // HUNDREDTHS: '^[0-9]{1,10}[\.]?[0-9]{1,2}$',
    NO_LIMIT_AFTER_DOT: '^[0-9]{1,10}[.]?[0-9]*$',
    ABOVE_ONE: '^[1-9]+[0-9]*$',
    NO_START_SPACE: '^[^ ]+.*$',
    NO_SPACE: '[^ ]*',
  },
};

Object.preventExtensions(constants);
export default constants;
